import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CustomButton from "../Button";
import { useLanguage } from "../../contexts/LanguageContext";
import styles from "./UploadLeaveWarningModal.module.scss";

interface UploadLeaveWarningModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "internal" | "external";
}

const UploadLeaveWarningModal: React.FC<UploadLeaveWarningModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  variant = "internal",
}) => {
  const { t } = useLanguage();

  return (
    <Modal
      centered
      title={
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t("uploadLeaveWarning.title")}</span>
          <CloseOutlined onClick={onCancel} className={styles.closeIcon} />
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      className={`${styles.warningModal} ${variant === "external" ? styles.warningModalExternal : ""}`}
      width={600}
    >
      <div className={styles.modalContent}>
        <div className={styles.content}>
          <p className={styles.mainText}>{t("uploadLeaveWarning.message")}</p>
        </div>
        <div className={styles.actionButtons}>
          <CustomButton onClick={onCancel} className={styles.cancelButton}>
            {t("common.cancel")}
          </CustomButton>
          <CustomButton onClick={onConfirm} className={styles.leaveButton}>
            {t("uploadLeaveWarning.leave")}
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default UploadLeaveWarningModal;
